import React, { lazy } from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section data-id="element-307">
      <h3 className="font-heading text-2xl md:text-3xl font-bold text-center mb-8 text-brand-title" data-id="element-308">
        📩 Lo que nos escriben después de aplicarlo:
      </h3>

      <div className="max-w-[850px] mx-auto space-y-8" data-id="element-309">
        <img src="https://cdn.magicpatterns.com/uploads/g7rS6c6X6PYGSF1isZhdDn/ChatGPT_Image_11_jun_2026,_09_31_12.webp" alt="Capturas de WhatsApp de instructoras satisfechas" width="850" height="600" loading="lazy" decoding="async" className="w-full rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)]" data-id="element-310" />

        <img src="https://cdn.magicpatterns.com/uploads/7XKiSoho4Vqfhkk4zjZm24/ChatGPT_Image_11_jun_2026,_10_00_40.webp" alt="Capturas de emails de instructoras satisfechas" width="850" height="600" loading="lazy" decoding="async" className="w-full rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)]" data-id="element-311" />
      </div>

      <p className="text-center text-brand-textMuted text-sm mt-6 italic" data-id="element-312">
        *Capturas de pantalla reales de instructoras en España.
      </p>

      <div className="text-center mt-8" data-id="element-313">
        <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-colors w-full md:w-auto tracking-wide shadow-gold-glow" data-id="element-314">
          🚀 QUIERO EL MANUAL AHORA
        </button>
      </div>
    </Section>;
}